import React from 'react';
import './index.scss';
// 只需要根据 Notification 组件传递的信息输出最终的内容
interface Props {
    type?: string;
    content?: string;
    children?: any;
}
const Toast: React.FC<Props> = (props) => {
    const { type, content, children } = props;
    return (
        <div className={`c-toast ${type}-notice`}>
            {children ? children : content}
        </div>
    );
};

export default React.memo(Toast);
